<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003600.filtration.controle.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    @if (this.actionStack!.getValue('elCModeFonctionnement') === 5) {
      <div class="bg-paid-orange p-3" style="border-radius: 10px">
        <div class="color-orange">
          {{ 'P00037.dashboard.electrolyseur.test.titre' | translate }}
        </div>
        <div>
          {{
            brandOverride('P00037.dashboard.electrolyseur.test.description')
              | translate
          }}
        </div>
      </div>
    } @else {
      <app-mode-control-multiple
        [datas]="getButtons()"
        [value]="
          this.actionStack!.getValue('elCModeFonctionnement') === 3
            ? 2
            : this.actionStack!.getValue('elCModeFonctionnement')
        "
        (onChange)="changeMode($event)"
      >
      </app-mode-control-multiple>
    }
  </div>
</div>
